import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, SERVISNI_PAKETY_DRUH } from './constants';

class ServisniPaketyApi extends BaseApi {
	tableUrl(tableName: string) {
		return `/${this.area}/${tableName}/`;
	}

	schemaUrl(tableName: string) {
		return `/${this.area}/${tableName}/Schema`;
	}

	addDruhSP(data: any) {
		this.post(`/${this.area}/${SERVISNI_PAKETY_DRUH}/UlozDruh`, data);
	}

	removeDruhSP(id: number) {
		this.delete(`/${this.area}/${SERVISNI_PAKETY_DRUH}/${id}`);
	}
}

export const apiProvider = new ServisniPaketyApi(DMS_MODULE, NAME);
